/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
// Cart Error functionality 
fetch('/cart.js')
    .then(response => response.json())
    .then(data => {
      var diyCount = 0;
      var nonDiyCount = 0;
      var pantryft = 0;

      console.log('Cart contents:', data);

      data.items.forEach(function(item) {
        var type = item.product_type;

        if (type === "Postable" || type === "GIST_BUILDER_PRODUCT") {
          diyCount++;
        } else if (type === "Final Touch" || type === "Gift Cards") {
          pantryft++;
        } else {
          nonDiyCount++;
        }
      });

      if (diyCount > 0 && nonDiyCount > 0) {
        const checkoutBtn = document.querySelector('a[name="checkout"]');
        if (checkoutBtn) {
          checkoutBtn.setAttribute('disabled', 'true');
        }

        alert('Your basket contains items with different delivery methods (i.e. local delivery / postable shipping / digital delivery). To proceed with your order, please adjust your basket so that each type of item is checked out separately.');
      }
    })
    .catch(error => console.error('Error fetching cart data:', error));
// End Cart Error functionality 
  


  document.addEventListener("DOMContentLoaded", function() {
    const validPrefixes = ["AL2", "BR1", "BR2", "BR3", "BR4", "BR5", "BR6", "BR7", "BR8", "CM1", "CM2", "CM4", "CM5", "CM11", "CM12", "CM13", "CM14", "CM15", "CM16", "CR0", "CR2", "CR3", "CR4", "CR5", "CR6", "CR7", "CR8", "DA1", "DA2", "DAS", "DA6", "DA7", "DA8", "DA14", "DA15", "DA16", "DA17", "DA18", "E1", "E2", "E4", "E5", "E6", "E7", "E8", "E9", "E10", "E11", "E12", "E13", "E14", "E15", "E16", "E17", "E18", "E19", "E20", "E1W", "EC1", "EC2", "EC3", "EC4", "ECA", "EN1", "EN2", "EN3", "EN4", "EN5", "EN6", "EN7", "EN8", "EN9", "HA0", "HA1", "HA2", "НАЗ", "HA4", "HA5", "HA6", "HA7", "HA8", "HA9", "IG1", "IG2", "IG3", "IG4", "IG5", "IG6", "IG7", "IG8", "IG9", "IG10", "IG11", "KT1", "KT2", "KT3", "KT4", "KT5", "KT6", "KT7", "KT8", "KT9", "KT10", "KT11", "KT12", "KT13", "KT14", "KT15", "KT16", "KT17", "KT18", "KT19", "KT20", "KT21", "KT22", "N1", "N2", "N3", "N4", "N5", "N6", "N7", "N8", "N9", "N10", "N11", "N12", "N13", "N14", "N15", "N16", "N17", "N18", "N19", "N20", "N21", "N22", "NW1", "NW2", "NW3", "NW4", "NW5", "NW6", "NW7", "NW8", "NW9", "NW10", "NW11", "RM1", "RM2", "RM3", "RM4", "RM5", "RM6", "RM7", "RM8", "RM9", "RM10", "RM11", "RM12", "RM13", "RM14", "RM15", "RM16", "RM17", "RM18", "RM19", "RM20", "SE1", "SE2", "SE3", "SE4", "SE5", "SE6", "SE7", "SE8", "SE9", "SE10", "SE11", "SE12", "SE13", "SE14", "SE15", "SE16", "SE17", "SE18", "SE19", "SE20", "SE21", "SE22", "SE23", "SE25", "SE26", "SE27", "SE28", "SL0", "SL9", "SM1", "SM2", "SM3", "SM4", "SM5", "SM6", "SM7", "SW1", "SW2", "SW3", "SW4", "SW5", "SW6", "SW7", "SW8", "SW9", "SW10", "SW11", "SW12", "SW13", "SW14", "SW15", "SW16", "SW17", "SW18", "SW19", "SW20", "TN14", "TN16", "TW1", "TW2", "TW3", "TW4", "TW5", "TW6", "TW7", "TW8", "TW9", "TW10", "TW11", "TW12", "TW13", "TW14", "TW15", "TW16", "TW17", "TW18", "TW19", "TW20", "UB1", "UB2", "UB3", "UB4", "UB5", "UB6", "UB7", "UB8", "UB9", "UB10", "UB11", "W1", "W2", "W3", "W4", "W5", "W6", "W7", "W8", "W9", "W10", "W11", "W12", "W13", "W14", "WC1", "WC2", "WD2", "WD3", "WD4", "WD5", "WD6", "WD7", "WD17", "WD18", "WD19", "WD23", "E3"];
    const checkBtn = document.getElementById("checkPostcode");
    const postcodeField = document.getElementById("postcodeField");
    const validMsg = document.getElementById("validPostcode");
    const invalidMsg = document.getElementById("invalidPostcode");

    checkBtn.addEventListener("click", function(e) {
      e.preventDefault();
      const userPostcode = postcodeField.value.trim().toUpperCase();

      // Hide both messages first
      validMsg.style.display = "none";
      invalidMsg.style.display = "none";

      // Show the correct one
      const isValid = validPrefixes.some(prefix => userPostcode.startsWith(prefix));
      if (isValid) {
        validMsg.style.display = "block";
      } else {
        invalidMsg.style.display = "block";
      }
    });
  });

  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
